import React, { useCallback, useMemo, useState, useEffect } from 'react';
import useDebounce from 'react-use/lib/useDebounce';
import { createStructuredSelector } from 'reselect';
import { useSelector } from 'react-redux';

import DisplayCSVPerformance from './DisplayCSVPerformance';
import { useFetchUploadedCSV } from 'query/metrics';
import { getUserDetails } from 'store/selectors/auth';
import { useCsvPerformanceStore } from './store';

const selector = createStructuredSelector({
  user: getUserDetails,
});

export default function CSVPerformance() {
  const {
    user: { id: myId, email: myEmail },
  } = useSelector(selector);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const {
    page,
    limit,
    selectedUsers,
    search,
    selectedTemplates,
    selectedESPs,
  } = useCsvPerformanceStore();

  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search],
  );

  const queryFilter = {
    page,
    limit,
    userIds: selectedUsers.map(e => e.id),
    templateIds: selectedTemplates.map(e => e.id),
    search: debouncedSearch,
    esps: selectedESPs,
  };

  const {
    data = { count: 0, data: [] },
    isFetching: isLoading,
    refetch: refetchUploadedCSV,
  } = useFetchUploadedCSV(queryFilter);

  const { count: countData, data: csvData } = data;

  console.log(csvData);

  const onRefresh = useCallback(() => {
    setIsRefreshing(true);
    refetchUploadedCSV();
  }, [refetchUploadedCSV]);

  useEffect(() => {
    // only show loading indicator for manual refetch
    if (isLoading === false) setIsRefreshing(false);
  }, [isLoading, isRefreshing]);

  const showLoadingIndicator = isRefreshing || (isLoading && !data.length);

  return useMemo(() => {
    return (
      <DisplayCSVPerformance
        isLoading={showLoadingIndicator}
        myEmail={myEmail}
        myId={myId}
        queryFilter={queryFilter}
        uploadedCSV={csvData?.map(v => ({ ...v, key: v.id }))}
        uploadedCSVCount={countData}
        onRefresh={onRefresh}
      />
    );
    // ignored loading from dependencies because every refresh triggers it.
  }, [
    page,
    limit,
    myId,
    myEmail,
    csvData,
    countData,
    onRefresh,
    showLoadingIndicator,
  ]);
}
